import { ComponentTypes } from '@model/contentful';

export const getAboveClimateTileIndices = ({ components }) => {
  if (!components) return undefined;
  return [
    components.findIndex(
      (component) => component.sys.contentType.sys.id === ComponentTypes.toursProductTileGroupComponent
    ),
    components.findIndex((component) => component.sys.contentType.sys.id === ComponentTypes.benefitGroupComponent)
  ];
};

export const getBelowClimateTileIndices = ({ components }) => {
  if (!components) return undefined;
  return components.findIndex(
    (component) => component.sys.contentType.sys.id === ComponentTypes.destinationGroupComponent
  );
};

export const getComponentIndexByTypeId = (components: Array<any>, typeId: string) => {
  if (!components) return undefined;
  return components.findIndex((component) => component.sys.contentType.sys.id === typeId);
};
